import { useEffect } from 'react';
import { getRateLimit } from '@/utils/http/twitter';
import { useRecoilState } from 'recoil';
import { appPointsAtom } from '@/state/app';

export const useTwitter = () => {
    const [appPoints, setAppPoints] = useRecoilState(appPointsAtom);
    useEffect(() => {
        getRateLimit().then((x) => {
            setAppPoints((previous) => ({
                ...previous,
                twitterLimit: x,
            }));
        });
    }, []);
};
